export enum ThemeTypes {
  NconnectVoiceTheme = "nconnect-voice-theme",
  O2SIPTrunkTheme = "o2-business-teams-telefonie-theme",
}
